import { Group } from "@mantine/core";

import { BackIcon, RestartIcon, HomeIcon } from "../assets";
import { GuideNavButton } from "./GuideNavButton";

interface GuideNavigationProps {
    isErrorState?: boolean;
    isLoading?: boolean;
    hasCompletedSteps: boolean;
    onBack: VoidFunction;
    onRestart: VoidFunction;
}

export function GuideNavigation({
    isErrorState,
    isLoading,
    hasCompletedSteps,
    onBack,
    onRestart,
}: GuideNavigationProps) {
    return (
        <Group justify="flex-end" gap="0rem" pt="xs">
            {!isErrorState && hasCompletedSteps && (
                <GuideNavButton
                    disabled={isLoading}
                    key="guide-navigation-button-back"
                    tooltip="Go back"
                    onClick={onBack}
                >
                    <BackIcon width={18} height={18} />
                </GuideNavButton>
            )}
            {hasCompletedSteps && (
                <GuideNavButton
                    disabled={isLoading}
                    key="guide-navigation-button-restart"
                    tooltip={isErrorState ? "Restart guide" : "Return home"}
                    onClick={onRestart}
                >
                    {isErrorState ? <RestartIcon width={18} height={18} /> : <HomeIcon width={18} height={18} />}
                </GuideNavButton>
            )}
        </Group>
    );
}
